/**
 * useOrgRequestMarketCounts hook (ST5)
 *
 * Fetches the per-request match/secured counts for the whole org in one call
 * (/api/tenant/requests/market-counts), keyed by request id. Drives the
 * "N gesichert / N Matches" badge on the requests list.
 */

"use client";

import { useState, useEffect, useCallback } from "react";
export interface OrgRequestMarketCount {
  matchCount: number;
  securedCount: number;
}
export function useOrgRequestMarketCounts() {
  const [counts, setCounts] = useState<Record<string, OrgRequestMarketCount>>({});
  const [isLoading, setIsLoading] = useState(true);
  const fetchCounts = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await fetch("/api/tenant/requests/market-counts");
      if (res.ok) {
        const json = await res.json();
        setCounts(json.data ?? {});
      }
    } catch {
      // non-fatal — badges simply don't render
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);
  return {
    counts,
    isLoading,
    refresh: fetchCounts
  };
}